/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AssetEncumbrance } from './AssetEncumbrance';
import {
    AssetEncumbranceFromJSON,
    AssetEncumbranceFromJSONTyped,
    AssetEncumbranceToJSON,
    AssetEncumbranceToJSONTyped,
} from './AssetEncumbrance';
import type { AssetFinancialHoldingKind } from './AssetFinancialHoldingKind';
import {
    AssetFinancialHoldingKindFromJSON,
    AssetFinancialHoldingKindFromJSONTyped,
    AssetFinancialHoldingKindToJSON,
    AssetFinancialHoldingKindToJSONTyped,
} from './AssetFinancialHoldingKind';

/**
 * 
 * @export
 * @interface AssetFinancialHoldingResponse
 */
export interface AssetFinancialHoldingResponse {
    /**
     * 
     * @type {string}
     * @memberof AssetFinancialHoldingResponse
     */
    id: string;
    /**
     * 
     * @type {AssetFinancialHoldingKind}
     * @memberof AssetFinancialHoldingResponse
     */
    kind: AssetFinancialHoldingKind;
    /**
     * 
     * @type {string}
     * @memberof AssetFinancialHoldingResponse
     */
    institutionName: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetFinancialHoldingResponse
     */
    accountNumber: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetFinancialHoldingResponse
     */
    street: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetFinancialHoldingResponse
     */
    houseNumber: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetFinancialHoldingResponse
     */
    zipCode: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetFinancialHoldingResponse
     */
    city: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetFinancialHoldingResponse
     */
    country: string | null;
    /**
     * 
     * @type {AssetEncumbrance}
     * @memberof AssetFinancialHoldingResponse
     */
    encumbrance: AssetEncumbrance | null;
    /**
     * 
     * @type {string}
     * @memberof AssetFinancialHoldingResponse
     */
    encumberedClaimId: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetFinancialHoldingResponse
     */
    usedForProceedingCosts: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetFinancialHoldingResponse
     */
    isValueKnown: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof AssetFinancialHoldingResponse
     */
    value: number | null;
    /**
     * 
     * @type {Date}
     * @memberof AssetFinancialHoldingResponse
     */
    valueDate: Date | null;
    /**
     * 
     * @type {string}
     * @memberof AssetFinancialHoldingResponse
     */
    remarks: string | null;
}



/**
 * Check if a given object implements the AssetFinancialHoldingResponse interface.
 */
export function instanceOfAssetFinancialHoldingResponse(value: object): value is AssetFinancialHoldingResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('kind' in value) || value['kind'] === undefined) return false;
    if (!('institutionName' in value) || value['institutionName'] === undefined) return false;
    if (!('accountNumber' in value) || value['accountNumber'] === undefined) return false;
    if (!('street' in value) || value['street'] === undefined) return false;
    if (!('houseNumber' in value) || value['houseNumber'] === undefined) return false;
    if (!('zipCode' in value) || value['zipCode'] === undefined) return false;
    if (!('city' in value) || value['city'] === undefined) return false;
    if (!('country' in value) || value['country'] === undefined) return false;
    if (!('encumbrance' in value) || value['encumbrance'] === undefined) return false;
    if (!('encumberedClaimId' in value) || value['encumberedClaimId'] === undefined) return false;
    if (!('usedForProceedingCosts' in value) || value['usedForProceedingCosts'] === undefined) return false;
    if (!('isValueKnown' in value) || value['isValueKnown'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    if (!('valueDate' in value) || value['valueDate'] === undefined) return false;
    if (!('remarks' in value) || value['remarks'] === undefined) return false;
    return true;
}

export function AssetFinancialHoldingResponseFromJSON(json: any): AssetFinancialHoldingResponse {
    return AssetFinancialHoldingResponseFromJSONTyped(json, false);
}

export function AssetFinancialHoldingResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetFinancialHoldingResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'kind': AssetFinancialHoldingKindFromJSON(json['kind']),
        'institutionName': json['institutionName'],
        'accountNumber': json['accountNumber'],
        'street': json['street'],
        'houseNumber': json['houseNumber'],
        'zipCode': json['zipCode'],
        'city': json['city'],
        'country': json['country'],
        'encumbrance': AssetEncumbranceFromJSON(json['encumbrance']),
        'encumberedClaimId': json['encumberedClaimId'],
        'usedForProceedingCosts': json['usedForProceedingCosts'],
        'isValueKnown': json['isValueKnown'],
        'value': json['value'],
        'valueDate': (json['valueDate'] == null ? null : new Date(json['valueDate'])),
        'remarks': json['remarks'],
    };
}

export function AssetFinancialHoldingResponseToJSON(json: any): AssetFinancialHoldingResponse {
    return AssetFinancialHoldingResponseToJSONTyped(json, false);
}

export function AssetFinancialHoldingResponseToJSONTyped(value?: AssetFinancialHoldingResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'kind': AssetFinancialHoldingKindToJSON(value['kind']),
        'institutionName': value['institutionName'],
        'accountNumber': value['accountNumber'],
        'street': value['street'],
        'houseNumber': value['houseNumber'],
        'zipCode': value['zipCode'],
        'city': value['city'],
        'country': value['country'],
        'encumbrance': AssetEncumbranceToJSON(value['encumbrance']),
        'encumberedClaimId': value['encumberedClaimId'],
        'usedForProceedingCosts': value['usedForProceedingCosts'],
        'isValueKnown': value['isValueKnown'],
        'value': value['value'],
        'valueDate': value['valueDate'] == null ? value['valueDate'] : `${value['valueDate'].getFullYear()}-${String(value['valueDate'].getMonth()+1).padStart(2,'0')}-${String(value['valueDate'].getDate()).padStart(2,'0')}`,
        'remarks': value['remarks'],
    };
}

